import { NAV_LIST, menuSlide, slide } from '@/constants';
import { cx } from '@/lib/utils';
import { motion } from 'motion/react';
import type { Route } from 'next';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { DispatchWithoutAction } from 'react';
import Curve from './Curve';

type MobileNavbarProps = {
  toggleMenu: DispatchWithoutAction;
};

const MobileNavbar = ({ toggleMenu }: MobileNavbarProps) => {
  const pathname = usePathname();

  return (
    <motion.div
      variants={menuSlide}
      initial="initial"
      animate="enter"
      exit="exit"
      aria-label="Main navigation"
      data-visible
      {...{ className: 'fixed right-0 top-0 z-40 size-full bg-[#f7e7ce] dark:bg-[#011322]' }}
    >
      <ul className="mt-48 flex size-full flex-col space-y-10 pr-8">
        {NAV_LIST.map((nav, index) => {
          const isActive = nav.href === pathname;

          return (
            <motion.li
              key={nav.key}
              custom={index}
              variants={slide}
              initial="initial"
              animate="enter"
              exit="exit"
              {...{
                className: cx(
                  'flex items-center justify-end text-[22px] uppercase text-brand',
                  isActive ? 'font-semibold opacity-100' : 'opacity-70',
                ),
              }}
            >
              <Link href={nav.href as Route} onClick={toggleMenu}>
                {nav.label}
              </Link>
            </motion.li>
          );
        })}
      </ul>
      <Curve />
    </motion.div>
  );
};

export default MobileNavbar;
